export {
  getSharedProfileAvatar as getDisplayAvatar,
  getSharedProfileBio as getDisplayBio,
  getSharedProfileDisplayName as getDisplayName,
} from '@litopia/shared/utils/profile-display';

export type { SharedProfileData as ProfileData } from '@litopia/shared/hooks';

/**
 * Get initial letter for avatar placeholder
 */
export function getInitial(displayName: string): string {
  return displayName.charAt(0).toUpperCase();
}
